import toMap from '~/misc/toMap';

export default toMap([
  'CITYRATIO_LIST_CRITERIA',
  'CITYRATIO_LIST_GET',
  'CITYRATIO_LIST_SORT',
  'CITYRATIO_LIST_MORE',
  'CITYRATIO_CHECKED',
  'CITYRATIO_CHECKED_ALL',
  'CITYRATIO_CLEAR_CHECKED',
  'CITYRATIO_UPDATE_CHECKED',
  'CITYRATIO_SHOW_MORE'
]);



// WEBPACK FOOTER //
// ./src/modules/cityRatioList/types.js